// NGRX STORE
import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';

// STORE STATE
import { MasterBusinessState } from './state';

/**
 * These selectors are for get data from master business reducer.
 * For get master business data from store purpose.
 *
 * @author Vikas Thakkar <vikas.thakkar@saeculumsolutions.com>
 *
 * Notes:-
 * Date: 27/4/2020 (Vikas Thakkar <vikas.thakkar@saeculumsolutions.com>)  created master business selectors
 */
export const selectState: MemoizedSelector<
  object,
  MasterBusinessState
> = createFeatureSelector<MasterBusinessState>('masterbusiness');

// -------------------------------
//  Master Business Common Selector
// -------------------------------
const getBusinessCommon = (state: MasterBusinessState): Array<any> => state.common;
export const selectBusinessCommon: MemoizedSelector<object, any> = createSelector(
  selectState,
  getBusinessCommon,
);

// -------------------------------
//  Stress Profile Selector
// -------------------------------
const getStressProfileLookUp = (state: MasterBusinessState): Array<any> => state.stressProfileLookup;
export const selectStressProfileList: MemoizedSelector<object, any> = createSelector(
  selectState,
  getStressProfileLookUp,
);

// -------------------------------
//  Employee Role Selector
// -------------------------------
const getEmployeeRoleList = (state: MasterBusinessState): Array<any> => state.employeeRoleLookup;
export const selectEmployeeRoleList: MemoizedSelector<object, any> = createSelector(
  selectState,
  getEmployeeRoleList,
);

// -------------------------------
//  Master Leave  Selector
// -------------------------------
const getMasterLeaveList = (state: MasterBusinessState): Array<any> => state.masterLeaveLookup;
export const selectMasterLeaveList: MemoizedSelector<object, any> = createSelector(
  selectState,
  getMasterLeaveList,
);
